import React, { Component } from "react";
class Post_survey extends Component {
  render() {
    return (
      <div style={{ textAlign: "center" }}>
        <p>Thank you for participating in testing!</p>
        {/* <p>All security popups that you saw during the platform were performed by us and your device has experienced no security threat.</p> */}
        <p>Please note your MTurk ID below for use in this post-survey!</p>
        <br></br>
        <p style={{fontWeight:"bolder"}}>MTurk ID: {localStorage.getItem("user_id")}</p>
        <br/>
        <iframe src="https://unlv.co1.qualtrics.com/jfe/form/SV_d5pCuEl8iBbBVbM" width="100%" height="600"></iframe>
      </div>
    );
  }
}

export default Post_survey;